// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "" + "4271c397e2b43b2a8cc2" + ".js";
};